import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// Import all your pages
import HomePage from '@/views/HomePage.vue'
import ContactPage from '@/pages/ContactPage.vue'
import ConditionsPage from '@/pages/ConditionsGeneralesPage.vue'
import SupportPage from '@/pages/SupportPage.vue'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage.vue'
import TermsOfSalePage from '@/pages/TermsOfSalePage.vue'
import AboutPage from '@/pages/AboutPage.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'
import LegalNotice from '@/views/LegalNotice.vue'
import DownloadPage from '@/pages/DownloadPage.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        meta: { title: 'PadelGo - Accueil' }
      },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: { title: 'PadelGo - Contact' }
  },
  {
    path: '/conditions',
    name: 'Conditions',
    component: ConditionsPage,
    meta: { title: 'PadelGo - Conditions Générales' }
  },
  {
    path: '/support',
    name: 'Support',
    component: SupportPage,
    meta: { title: 'PadelGo - Support' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage,
    meta: { title: 'PadelGo - Politique de Confidentialité' }
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: ConditionsPage,
    meta: { title: 'PadelGo - Conditions d\'Utilisation' }
  },
  {
    path: '/terms-of-sale',
    name: 'TermsOfSale',
    component: TermsOfSalePage,
    meta: { title: 'PadelGo - Conditions Générales de Vente' }
  },
  {
    path: '/legal-notice',
    name: 'LegalNotice',
    component: LegalNotice,
    meta: { title: 'PadelGo - Mentions Légales' }
  },
  {
    path: '/download',
    name: 'Download',
    component: DownloadPage,
    meta: { title: 'PadelGo - Télécharger' }
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: AboutPage,
  //   meta: { title: 'PadelGo - À Propos' }
  // },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: { title: 'PadelGo - Page Non Trouvée' }
  }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        if (to.hash === '#notify-me') {
          return {
            el: to.hash,
            behavior: 'smooth',
            top: window.innerHeight / 2 - 100 // Center in viewport with some offset for header
          }
        }
        return {
          el: to.hash,
          behavior: 'smooth',
          top: 80 // Default offset for fixed header
        }
      }
      return { top: 0, behavior: 'smooth' }
    }
  })

export default router